module.exports = __webpack_public_path__ + "static/media/Frame 323.578fb437.png";